import React from 'react';
import styles from './SideFlagXPGain.module.scss';
import { useTranslation } from 'react-i18next';
import TowerTokenIcon from '../../assets/imgs/tower-token 1.png';

const SideFlagXPGain = ({ earn_xp, rewards_pool }) => {
    const [t] = useTranslation();

    return (
        <div className={styles.reward_container}>
                <div className={styles.star_rewards}>
                    <div className={styles.reward_banner}>
                        <div className={styles.convo_bubble}>
                            <div>{t('GAIN')} {earn_xp} {t('XP_TO_EARN_REWARDS_POOL')}</div>
                            <div className={styles.tower_amount}>
                                <img src={TowerTokenIcon} alt="tower-token" />
                                <div>{rewards_pool}</div>
                            </div>
                        </div>

                        <div className={styles.event_details_link}>
                            <a href="https://medium.com/tower-token/" target="_blank" rel="noopener noreferrer">
                                {t('EVENT_DETAILS')}
                            </a>
                        </div>
                    </div>
                </div>
        </div>
    )
}

export { SideFlagXPGain }
